import pt from 'prop-types';
import React, { useEffect, useState } from 'react';
import ArrowTopIcon from '../../images/arrow-top.svg';

const ScrollToTopButton = ({ className }) => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
  }, []);

  return visible ? (
    <div role="button" onClick={scrollToTop} className={className}>
      <ArrowTopIcon />
    </div>
  ) : null;
};

ScrollToTopButton.propTypes = {
  className: pt.string,
};

ScrollToTopButton.defaultProps = {
  className: '',
};

export default ScrollToTopButton;
